import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import globalContext from "../../Contexts/GlobalContext";
import { HiRefresh } from "react-icons/hi";
import { RxLapTimer } from "react-icons/rx";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import useRequestHeader from "../../hooks/useRequestHeader";

export default function VerifyTimer({ setMessageError, setVerifyLoader }) {
  //  context data section start
  const contextData = useContext(globalContext);
  const navigate = useNavigate();
  const [cookies, removeCookies] = useCookies();
  const requestHeaderNoToken = useRequestHeader("noToken");
  //  context data section end

  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///

  const [second, setSecond] = useState(59);
  const [minutes, setMinutes] = useState("02");
  const [showRefreshBtn, setShowRefreshBtn] = useState(false);

  /// send code again function start ///
  const sendAgainCode = () => {
    setMessageError("");
    setVerifyLoader(true);
    const config = {
      headers: requestHeaderNoToken,
    };
    axios
      .post(
        `${BASE_URL}/user/register`,
        {
          user: contextData.loginPhoneNumber,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            contextData.setIsToastOpen(true);
            contextData.setToastMessage("کد تأیید مجدد برای شما ارسال شد");
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }

        setVerifyLoader(false);
      })
      .catch((err) => {
        setMessageError("ارتباط با سرور دچار مشکل  شده است");
        setVerifyLoader(false);
      });
  };
  /// send code again function end ///

  useEffect(() => {
    if (!(minutes === "00" && second == 0)) {
      setTimeout(() => {
        if (second === 0 && minutes === "02") {
          setMinutes("01");
          setSecond(59);
        }
        if (second === 0 && minutes === "01") {
          setMinutes("00");
          setSecond(59);
        }
        if (second > 0) {
          setSecond(second - 1);
        }
      }, 1000);
    } else if (minutes === "00" && second == 0) {
      setShowRefreshBtn(true);
    }
  }, [second, minutes]);

  return (
    <>
      <div className="bg-[#153038] flex justify-center items-center px-[2vw] py-[1vw] rounded-[0.9vw]">
        <span className="pl-[1vw] text-color-primary-B">
          <RxLapTimer size={18} />
        </span>
        <p
          dir="ltr"
          className="text-center font-semibold text-[4vw] z-50 text-color-primary-B font-font_primary_A"
        >
          {`${minutes} : ${second < 10 ? `0${second}` : `${second}`} `}
        </p>
      </div>
      <button
        className={`flex items-center justify-center text-[#FFF] text-[3.5vw] font-font_primary_A z-[60] px-[2vw] ${
          showRefreshBtn ? "" : "hidden"
        }`}
        onClick={() => {
          setMinutes("02");
          setSecond(59);
          setShowRefreshBtn(false);
          sendAgainCode();
        }}
      >
        <HiRefresh size={23} />
      </button>
    </>
  );
}
